module.exports = __webpack_public_path__ + "static/media/team-bg-2.ec7a058d.jpg";